import { Divider, Grid } from "@mui/material";
import moment from "moment";
import React, { useEffect, useState } from "react";


const Reports = ({ data,deductionVendor }) => {
  const deductionVendorSum = deductionVendor?.reduce((accumulator, currentItem) => {
    accumulator.Deduction_Value += currentItem.Deduction_Value;
    accumulator.Deduction_Amount_ytd += currentItem.Deduction_Amount_ytd;
    return accumulator;
}, { Deduction_Value: 0, Deduction_Amount_ytd: 0 });

const [newData,setNewData] = useState([])

// useEffect(()=>{
//   if(data && data.length>0){
//     if(data[0]['Retirement_Type']==='NB'){
//       // alert("1")
//       data[0]['Ppe_Retire_Db_Deduction'] = data?.[0]?.['Ppe_Nonbase_Deduction']??0
//       data[0]['Ytd_Retire_Db_Deduction'] = data?.[0]?.['Ytd_Nonbase_Deduction']??0
//       console.log(data[0]['Ytd_Retire_Db_Deduction'],data[0]['Ytd_Retire_Dc_Deduction'],"Ytd_Retire_Dc_Deduction")
//     }
//     setNewData([...data])
//     }
// },[data])
if(data[0]['Retirement_Type']==='NB'){
  // alert("1")
  data[0]['Ppe_Retire_Db_Deduction'] = data?.[0]?.['Ppe_Nonbase_Deduction']??0
  data[0]['Ytd_Retire_Db_Deduction'] = data?.[0]?.['Ytd_Nonbase_Deduction']??0
  // console.log(data[0]['Ytd_Retire_Db_Deduction'],data[0]['Ytd_Retire_Dc_Deduction'],"Ytd_Retire_Dc_Deduction")
}

  return (
    <>
      {/* Employee details   */}
      <div className="earning_detail">
        {data.map((employee, index) => (
          <div key={index}>
            <Grid container>
              <Grid item xs={8}>
                <table >
                  <tbody>
                    <tr>
                      <td>
                        Employee number :-
                      </td>
                      <td>
                        {employee.EmployeeId}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Employee Name :-
                      </td>
                      <td>{employee.Employee_Name}</td>
                    </tr>
                    <tr>
                      <td>
                        Pay Period Ending :-
                      </td>
                      <td>
                        {moment(employee.Pay_Period_Ending_date).format("MM/DD/yyyy")}
                      </td>

                    </tr>
                    <tr>
                      <td>
                        Check Amount :-
                      </td>
                      <td>
                        {Number(employee?.Check_Amount??0)?.toLocaleString('en-US', {
                          style: 'currency',
                          currency: 'USD',
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Net Pay :-
                      </td>
                      <td>
                        {Number(employee?.Ppe_Net_Pay??0)?.toLocaleString('en-US', {
                          style: 'currency',
                          currency: 'USD',
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </Grid>
              <Grid item xs={4}>
                <table >
                  <tbody>
                    <tr>
                      <td>Dept :-</td>
                      <td>{employee.Dept_Code??"--"}</td>
                    </tr>
                    <tr>

                    </tr>
                    <tr>
                      <td>Hourly Rate :-</td>
                      <td>{Number(employee.Hourly_RATE).toLocaleString('en-US', {
                        style: 'currency',
                        currency: 'USD',
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}</td>
                    </tr>
                    <tr>
                      <td>Check Number :-</td>
                      <td>{employee.Check_Number==0?'NET EFT':employee.Check_Number}</td>
                    </tr>
                    <tr>
                      <td>Check Date :-</td>
                      <td>{moment(employee?.Check_Date??employee?.check_date).format("MM/DD/YYYY")}</td>
                    </tr>
                    <tr>
                      <td>Check Sequence :-</td>
                      <td>{employee?.Check_Sequence??employee?.check_seq}</td>
                    </tr>
                  </tbody>
                </table>
              </Grid>
            </Grid>
            <Divider style={{ height: '3px', backgroundColor: 'red', margin: '10px 0' }} />
            <div style={{display:"flex"}}>
            <div style={{width:"65%"}}>
            <Grid container spacing={2} >
              <Grid item xs={7}>
                <table style={{ width: '80%' }}>
                  <thead>
                    <tr>
                      <td style={{ fontWeight: 'bold', textDecoration: 'underline',whiteSpace: "nowrap" }}>
                        EARNINGS INFORMATION
                      </td>
                      

                    </tr>
                    <tr>
                      <td></td>
                    <td colSpan={2} align="right" style={{ paddingLeft: '20px', fontWeight:'500' }}>
                        ----- Hours -----
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td></td>
                      <td align="right" style={{fontWeight:'500'}}>Current</td>
                      <td align="right" style={{fontWeight:'500'}}>YTD</td>
                    </tr>
                    <tr>
                      <td style={{whiteSpace: "nowrap"}}>
                        Work hours
                      </td>
                      <td align="right">
                        {Number(employee.Ppe_Regular_Hours)}
                      </td>
                      <td align="right">{Number(employee.Ytd_Regular_Hours)}</td>
                    </tr>
                    <tr>
                      <td style={{whiteSpace: "nowrap"}}>
                        Annual Leave
                      </td>
                      <td align="right">
                        {Number(employee.Ppe_Al_Hours)}
                      </td>
                      <td align="right">{Number(employee.Ytd_Al_Hours)}</td>
                    </tr>
                    <tr>
                      <td style={{whiteSpace: "nowrap"}}>
                        Sick Leave
                      </td>
                      <td align="right">
                        {Number(employee.Ppe_Sl_Hours)}
                      </td>
                      <td align="right">{Number(employee.Ytd_Sl_Hours)}</td>
                    </tr>
                    <tr>
                      <td style={{whiteSpace: "nowrap"}}>
                        Other Leave
                      </td>
                      <td align="right">
                        {Number(employee.Ppe_Other_Lve_Hours)}
                      </td>
                      <td align="right">{Number(employee.Ytd_Other_Leave_Hours)}</td>
                    </tr>
                    <tr>
                      <td style={{whiteSpace: "nowrap"}}>
                        Premium Pay
                      </td>
                      <td align="right">
                        {Number(employee.Ppe_Premium_Hours)}
                      </td>
                      <td align="right">{Number(employee.Ytd_Premium_Hours)}</td>
                    </tr>
                    <tr>
                      <td>
                        Overtime
                      </td>
                      <td align="right">
                        {Number(employee.Ppe_Overtime_Hours)}
                      </td>
                      <td align="right">{Number(employee.Ytd_Overtime_Hours)}</td>
                    </tr>
                    <tr>
                      <td style={{whiteSpace: "nowrap"}}>
                        Retroactive Pay
                      </td>
                      <td align="right">
                        {Number(employee.Ppe_Retro_Hours)}
                      </td>
                      <td align="right">{Number(employee.Ytd_Retro_Hours)}</td>
                    </tr>
                    <tr>
                      <td style={{whiteSpace: "nowrap"}}>
                        Other Pay
                      </td>
                      <td align="right">
                        {Number(employee.ppe_Other_Pay_Hours??0)}
                      </td>
                      <td align="right">{Number(employee.ytd_Other_Pay_Hours??0)}</td>
                    </tr>
                    <tr>
                      <td style={{ paddingLeft: "15px", fontWeight: 'bold',whiteSpace: "nowrap" }}>
                        Gross pay
                      </td>
                      <td>

                      </td>
                      <td></td>
                    </tr>
                    <tr>
                      <td style={{whiteSpace: "nowrap"}}>
                        Tax Deffered Amount
                      </td>

                    </tr>
                    <tr >
                      <td style={{ paddingLeft: "15px", fontWeight: 'bold',whiteSpace: "nowrap" }}>
                        Adjusted Gross Pay
                      </td>
                      <td>

                      </td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>
              </Grid>
              <Grid item xs={4}>
                <table style={{ width: '100%' }}>
                  <thead style={{ height: '45px' }}>
                    <tr>
                      <td></td>
                      <td></td>
                    </tr>
                    <tr>
                      <td></td>
                      <td></td>
                    </tr>

                    {/* <tr>
                      <td></td>
                      <td></td>
                    </tr> */}
                  </thead>
                  <tbody>
                    <tr>
                      <td align="right" style={{fontWeight:'500'}}>Current</td>
                      <td align="right" style={{fontWeight:'500'}}>YTD</td>
                    </tr>
                    <tr>
                      <td align="right">
                      <div style={{display:"flex",justifyContent:"space-between"}}>
                        <span style={{fontWeight:'400'}}>${" "}</span>
                        {Number(employee.Ppe_Regular_Earnings)?.toLocaleString('en-US', {
                          // style: 'currency',
                          // currency: 'USD',
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </div>
                      </td>
                      <td align="right">
                        <div style={{display:"flex",justifyContent:"space-between"}}>
                          <span style={{fontWeight:'400'}}>${" "}</span>
                          {employee.Ytd_Regular_Earnings?.toLocaleString('en-US', {
                          // style: 'currency',
                          // currency: 'USD',
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                          })}
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td align="right">
                        <div style={{display:"flex",justifyContent:"space-between"}}>
                          <span style={{fontWeight:'400'}}>${" "}</span>
                          {employee.Ppe_Al_Amount?.toLocaleString('en-US', {
                          // style: 'currency',
                          // currency: 'USD',
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                          })}
                        </div>
                      </td>
                      <td align="right">
                      <div style={{display:"flex",justifyContent:"space-between"}}>
                          <span style={{fontWeight:'400'}}>${" "}</span>
                          {employee.Ytd_Al_Amount?.toLocaleString('en-US', {
                          // style: 'currency',
                          // currency: 'USD',
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                          })}
                          </div>
                      </td>
                    </tr>
                    <tr>
                      <td align="right">
                        <div style={{display:"flex",justifyContent:"space-between"}}>
                          <span style={{fontWeight:'400'}}>${" "}</span>
                          {employee.Ppe_Sl_Amount?.toLocaleString('en-US', {
                          // style: 'currency',
                          // currency: 'USD',
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                          })}
                        </div>
                      </td>
                      <td align="right">
                        <div style={{display:"flex",justifyContent:"space-between"}}>
                          <span style={{fontWeight:'400'}}>${" "}</span>
                          {employee.Ytd_Sl_Amount?.toLocaleString('en-US', {
                          // style: 'currency',
                          // currency: 'USD',
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                          })}
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td align="right">
                        <div style={{display:"flex",justifyContent:"space-between"}}>
                          <span style={{fontWeight:'400'}}>${" "}</span>
                          {employee.Ppe_Other_Leave_Amt?.toLocaleString('en-US', {
                          // style: 'currency',
                          // currency: 'USD',
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                          })}
                        </div>
                      </td>
                      <td align="right">
                        <div style={{display:"flex",justifyContent:"space-between"}}>
                          <span style={{fontWeight:'400'}}>${" "}</span>
                          {Number(employee.Ytd_Other_Leave_Amt)?.toLocaleString('en-US', {
                          // style: 'currency',
                          // currency: 'USD',
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                          })}
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td align="right">
                        <div style={{display:"flex",justifyContent:"space-between"}}>
                          <span style={{fontWeight:'400'}}>${" "}</span>
                          {Number(employee.Ppe_Premium_Amount)?.toLocaleString('en-US', {
                          // style: 'currency',
                          // currency: 'USD',
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                          })}
                        </div>
                      </td>
                      <td align="right">
                        <div style={{display:"flex",justifyContent:"space-between"}}>
                          <span style={{fontWeight:'400'}}>${" "}</span>
                          {Number(employee.Ytd_Premium_Amount)?.toLocaleString('en-US', {
                          // style: 'currency',
                          // currency: 'USD',
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                          })}
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td align="right">
                        <div style={{display:"flex",justifyContent:"space-between"}}>
                          <span style={{fontWeight:'400'}}>${" "}</span>
                          {Number(employee.Ppe_Overtime_Amount)?.toLocaleString('en-US', {
                          // style: 'currency',
                          // currency: 'USD',
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                          })}
                        </div>
                      </td>
                      <td align="right">
                        <div style={{display:"flex",justifyContent:"space-between"}}>
                          <span style={{fontWeight:'400'}}>${" "}</span>
                          {Number(employee.Ytd_Overtime_Amount)?.toLocaleString('en-US', {
                          // style: 'currency',
                          // currency: 'USD',
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                          })}
                        </div>
                      </td>
                    </tr>
                    <tr style={{ minHeight: '25px' }}>
                      <td align="right">
                        <div style={{display:"flex",justifyContent:"space-between"}}>
                          <span style={{fontWeight:'400'}}>${" "}</span>
                        {Number(employee.Ppe_Retro_Amt??0)?.toLocaleString('en-US', {
                          // style: 'currency',
                          // currency: 'USD',
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                        </div>  
                      </td>
                      <td align="right">
                        <div style={{display:"flex",justifyContent:"space-between"}}>
                          <span style={{fontWeight:'400'}}>${" "}</span>
                          {Number(employee.Ytd_Retro_Amt??0)?.toLocaleString('en-US', {
                          // style: 'currency',
                          // currency: 'USD',
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                          })}  
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td align="right">
                        <div style={{display:"flex",justifyContent:"space-between"}}>
                          <span style={{fontWeight:'400'}}>${" "}</span>
                          {Number(employee.Ppe_Other_Pay_Amount)?.toLocaleString('en-US', {
                          // style: 'currency',
                          // currency: 'USD',
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                          })}
                        </div>
                      </td>
                      <td align="right">
                        <div style={{display:"flex",justifyContent:"space-between"}}>
                          <span style={{fontWeight:'400'}}>${" "}</span>
                          {Number(employee.Ytd_Other_Pay_Amount)?.toLocaleString('en-US', {
                          // style: 'currency',
                          // currency: 'USD',
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                          })}
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td align="right">
                       <div style={{display:"flex",justifyContent:"space-between",fontWeight:'bold'}}>
                          <span>${" "}</span>
                          {Number(employee.Ppe_Gross_Earnings)?.toLocaleString('en-US', {
                          // style: 'currency',
                          // currency: 'USD',
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                          })}
                        </div>
                      </td>
                      <td align="right">
                        <div style={{display:"flex",justifyContent:"space-between",fontWeight:'bold'}}>
                          <span>${" "}</span>
                          {Number(employee.Ytd_Gross_Earnings)?.toLocaleString('en-US', {
                          // style: 'currency',
                          // currency: 'USD',
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                          })}
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td align="right">
                        <div style={{display:"flex",justifyContent:"space-between"}}>
                          <span style={{fontWeight:'400'}}>${" "}</span>
                          {Number(employee.Ppe_Tax_Defered_Amount)?.toLocaleString('en-US', {
                          // style: 'currency',
                          // currency: 'USD',
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                          })}
                        </div>
                      </td>
                      <td align="right">
                        <div style={{display:"flex",justifyContent:"space-between"}}>
                          <span style={{fontWeight:'400'}}>${" "}</span>
                          {Number(employee.Ytd_Tax_Defered_Amount)?.toLocaleString('en-US', {
                          // style: 'currency',
                          // currency: 'USD',
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                          })}
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td align="right">
                        <div style={{display:"flex",justifyContent:"space-between",fontWeight:'bold'}}>
                          <span>${" "}</span>
                          {Number(employee.Ppe_Gross_Earnings - employee.Ppe_Tax_Defered_Amount)?.toLocaleString('en-US', {
                          // style: 'currency',
                          // currency: 'USD',
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                          })}
                        </div>
                      </td>
                      <td align="right">
                        <div style={{display:"flex",justifyContent:"space-between",fontWeight:'bold'}}>
                          <span>${" "}</span>
                          {Number(employee.Ytd_Gross_Earnings - employee.Ytd_Tax_Defered_Amount)?.toLocaleString('en-US', {
                          // style: 'currency',
                          // currency: 'USD',
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                          })}
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </Grid>
            </Grid>
            </div>
            <div style={{width:"35%"}}>
            <Grid container spacing={2} >
              <Grid item xs={12}>
                <table style={{ width: '100%' }}>
                  <thead>
                    <tr>
                      <td style={{ fontWeight: 'bold', textDecoration: 'underline',whiteSpace: "nowrap" }}>
                        LEAVE INFORMATION
                      </td>
                      

                    </tr>
                    <tr>
                      <td></td>
                    <td colSpan={2} align="right" style={{ paddingLeft: '20px', fontWeight:'500' }}>
                        ----- Hours -----
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td style={{fontWeight:'500',whiteSpace: "nowrap"}}>Annual Leave</td>
                      <td align="right" style={{fontWeight:'500'}}>Current</td>
                      <td align="right" style={{fontWeight:'500'}}>YTD</td>
                    </tr>
                    <tr>
                      <td style={{ paddingLeft: "15px" }}>
                        Accrued
                      </td>
                      <td align="right">
                        {Number(employee.Ppe_Al_Hours_Accrued)}
                      </td>
                      <td align="right">{Number(employee.Ytd_Al_Hours_Accrued)}</td>
                    </tr>
                    <tr>
                      <td style={{ paddingLeft: "15px", whiteSpace: "nowrap"}}>
                        Received (donated)
                      </td>
                      <td align="right">
                        {Number(employee.Ppe_Transferred_Al_Received)}
                      </td>
                      <td align="right">{Number(employee.Ytd_Transferred_Al_Received)}</td>
                    </tr>
                    <tr>
                      <td style={{ paddingLeft: "15px" }}>
                        Used
                      </td>
                      <td align="right">
                        {Number(employee.Ppe_Al_Hours)}
                      </td>
                      <td align="right">{Number(employee.Ytd_Al_Hours)}</td>
                    </tr>
                    <tr>
                      <td style={{ paddingLeft: "15px" }}>
                        Balance
                      </td>
                      <td align="right">
                        {Number(employee.Annual_Leave_Balance)}
                      </td>
                      <td align="right">
                        {Number(employee.Annual_Leave_Balance)}
                      </td>
                    </tr>
                    <tr>
                      <td style={{fontWeight:'500',whiteSpace: "nowrap"}}>
                        Sick Leave
                      </td>

                    </tr>
                    <tr>
                      <td style={{ paddingLeft: "15px" }}>
                        Accrued
                      </td>
                      <td align="right">
                        {Number(employee.Ppe_Sl_Hours_Accrued)}
                      </td>
                      <td align="right">{Number(employee.Ytd_Sl_Hours_Accrued)}</td>
                    </tr>
                    <tr>
                      <td style={{ paddingLeft: "15px",whiteSpace: "nowrap" }}>
                        Received (donated)
                      </td>
                      <td align="right">
                        {Number(employee.Ppe_Transferred_Sl_Received)}
                      </td>
                      <td align="right">{Number(employee.Ytd_Transferred_Sl_Received)}</td>
                    </tr>
                    <tr>
                      <td style={{ paddingLeft: "15px" }}>
                        Used
                      </td>
                      <td align="right">
                        {Number(employee.Ppe_Sl_Hours)}
                      </td>
                      <td align="right">{Number(employee.Ytd_Sl_Hours)}</td>
                    </tr>
                    <tr>
                      <td style={{ paddingLeft: "15px", }}>
                        Balance
                      </td>
                      <td align="right">
                      {Number(employee?.Sick_Leave_Balance??0)}
                      </td>
                      <td align="right">
                      {Number(employee?.Sick_Leave_Balance??0)}
                      </td>
                    </tr>
                    {/* //Compensatory data is not available */}
                    <tr>
                      <td style={{fontWeight:'500',whiteSpace: "nowrap"}}>
                        Compensatory Leave
                      </td>
                    </tr>
                    <tr>
                      <td style={{ paddingLeft: "15px" }}>Accrued</td>
                      <td align="right">
                        {Number(employee?.Ppe_Ct_Hours_Accrued??0)}
                      </td>
                      <td align="right">
                        {Number(employee?.Ytd_Ct_Hours_Accrued??0)}
                      </td>
                    </tr>
                    <tr>
                      <td style={{ paddingLeft: "15px" }}>Balance</td>
                      <td align="right">
                        {Number(employee?.Comp_Time_Accrued_Balance??0)}
                      </td>
                      <td align="right">
                        {Number(employee?.Comp_Time_Accrued_Balance??0)}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </Grid>
            </Grid>
            </div>
            </div>
            
            <Divider style={{ height: '3px', backgroundColor: 'red', margin: '10px 0' }} />

            

            {/* <Divider style={{ height: '3px', backgroundColor: 'red', margin: '10px 0' }} /> */}

            <Grid container spacing={2} >
              <Grid item xs={11} paddingRight={"1px"}>
                <table style={{ width: '100%' }}>
                  <thead>
                    <tr>
                      <td style={{ fontWeight: 'bold', textDecoration: 'underline',whiteSpace: "nowrap" }}>
                        WITHHOLDING & DEDUCTION INFORMATION
                      </td>
                      <td align="right" style={{fontWeight:'500'}}>
                        Current
                      </td>
                      <td align="right" style={{fontWeight:'500'}}>
                        YTD
                      </td>

                    </tr>
                  </thead>
                  <tbody>
                    {/* <tr>
                      <td>
                        Guam Withholding Tax
                      </td>
                      <td align="right">
                        <div style={{display:'flex', justifyContent:'space-between'}}>
                          <span style={{fontWeight:'400'}}>${" "}</span>
                          {Number(employee?.Ppe_Guam_Withholding_Tax??0)?.toLocaleString('en-US', {
                          // style: 'currency',
                          // currency: 'USD',
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                          })}
                        </div>
                        </td>
                        <td align="right">
                        <div style={{display:'flex', justifyContent:'space-between'}}>
                          <span style={{fontWeight:'400'}}>${" "}</span>
                          {Number(employee?.Ytd_Guam_Withholding_Tax??0)?.toLocaleString('en-US', {
                          // style: 'currency',
                          // currency: 'USD',
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                          })}
                        </div>
                      </td>
                    </tr> */}
                    {/* <tr>
                      <td>
                        Guam Additional Tax
                      </td>
                      <td align="right">
                        <div style={{display:'flex', justifyContent:'space-between'}}>
                          <span style={{fontWeight:'400'}}>${" "}</span>
                          {Number(employee?.Ppe_Guam_Additional_Tax??0)?.toLocaleString('en-US', {
                          // style: 'currency',
                          // currency: 'USD',
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                          })}
                        </div>
                        </td>
                        <td align="right">
                        <div style={{display:'flex', justifyContent:'space-between'}}>
                          <span style={{fontWeight:'400'}}>${" "}</span>
                          {Number(employee?.Ytd_Guam_Additional_Tax??0)?.toLocaleString('en-US', {
                          // style: 'currency',
                          // currency: 'USD',
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                          })}
                        </div>
                      </td>
                    </tr> */}
                    <tr>
                      <td >Guam income tax</td>
                      <td align="right">
                        <div style={{display:'flex', justifyContent:'space-between'}}>
                          <span style={{fontWeight:'400'}}>${" "}</span>
                          {(Number(employee?.Ppe_Guam_Withholding_Tax??0))?.toFixed(2)?.toLocaleString('en-US', {
                          // style: 'currency',
                          // currency: 'USD',
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                          })}
                        </div>
                        </td>
                      <td align="right">
                        <div style={{display:'flex', justifyContent:'space-between'}}>
                          <span style={{fontWeight:'400'}}>${" "}</span>
                          {(Number(employee?.Ytd_Guam_Withholding_Tax??0))?.toFixed(2)?.toLocaleString('en-US', {
                          // style: 'currency',
                          // currency: 'USD',
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                          })}
                        </div>
                      </td>
                    </tr>

                    {/* <tr>
                      <td>
                        Federal Withholding tax
                      </td>
                      <td align="right">
                        <div style={{display:'flex', justifyContent:'space-between'}}>
                          <span style={{fontWeight:'400'}}>${" "}</span>
                          {Number(employee?.Ppe_Federal_Withholding_Tax??0)?.toLocaleString('en-US', {
                          // style: 'currency',
                          // currency: 'USD',
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                          })}
                        </div>  
                      </td>
                      <td align="right">
                        <div style={{display:'flex', justifyContent:'space-between'}}>
                          <span style={{fontWeight:'400'}}>${" "}</span>
                          {Number(employee?.Ytd_Federal_Withholding_Tax??0)?.toLocaleString('en-US', {
                          // style: 'currency',
                          // currency: 'USD',
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                          })}
                        </div>
                      </td>
                    </tr> */}
                    {/* <tr>
                      <td>
                        Federal Additional tax
                      </td>
                      <td align="right">
                        <div style={{display:'flex', justifyContent:'space-between'}}>
                          <span style={{fontWeight:'400'}}>${" "}</span>
                          {Number(employee?.Ppe_Federal_Additional_Tax??0)?.toLocaleString('en-US', {
                          // style: 'currency',
                          // currency: 'USD',
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                          })}
                        </div>  
                      </td>
                      <td align="right">
                        <div style={{display:'flex', justifyContent:'space-between'}}>
                          <span style={{fontWeight:'400'}}>${" "}</span>
                          {Number(employee?.Ytd_Federal_Additional_Tax??0)?.toLocaleString('en-US', {
                          // style: 'currency',
                          // currency: 'USD',
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                          })}
                        </div>
                      </td>
                    </tr> */}
                    <tr>
                      <td >
                        Federal income tax
                      </td>
                      <td align="right">
                        <div style={{display:'flex', justifyContent:'space-between'}}>
                          <span style={{fontWeight:'400'}}>${" "}</span>
                          {(Number(employee?.Ppe_Federal_Withholding_Tax??0)+Number(employee?.Ppe_Federal_Additional_Tax??0))?.toFixed(2)?.toLocaleString('en-US', {
                          // style: 'currency',
                          // currency: 'USD',
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                          })}
                        </div>  
                      </td>
                      <td align="right">
                        <div style={{display:'flex', justifyContent:'space-between'}}>
                          <span style={{fontWeight:'400'}}>${" "}</span>
                          {(Number(employee?.Ytd_Federal_Withholding_Tax??0)+Number(employee?.Ytd_Federal_Additional_Tax??0))?.toFixed(2)?.toLocaleString('en-US', {
                          // style: 'currency',
                          // currency: 'USD',
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                          })}
                        </div>
                      </td>
                    </tr>

                    {/* <tr>
                      <td>
                        State Withholding tax
                      </td>
                      <td align="right">
                        <div style={{display:'flex', justifyContent:'space-between'}}>
                          <span style={{fontWeight:'400'}}>${" "}</span>
                          {Number(employee?.Ppe_State_Withholding_Tax??0)?.toLocaleString('en-US', {
                          // style: 'currency',
                          // currency: 'USD',
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                          })}
                        </div>  
                      </td>
                      <td align="right">
                        <div style={{display:'flex', justifyContent:'space-between'}}>
                          <span style={{fontWeight:'400'}}>${" "}</span>
                          {Number(employee?.Ytd_State_Withholding_Tax??0)?.toLocaleString('en-US', {
                          // style: 'currency',
                          // currency: 'USD',
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                          })}
                        </div>
                      </td>
                    </tr> */}
                    {/* <tr>
                      <td>
                        State Additional tax
                      </td>
                      <td align="right">
                        <div style={{display:'flex', justifyContent:'space-between'}}>
                          <span style={{fontWeight:'400'}}>${" "}</span>
                          {Number(employee?.Ppe_State_Additional_Tax??0)?.toLocaleString('en-US', {
                          // style: 'currency',
                          // currency: 'USD',
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                          })}
                        </div>  
                      </td>
                      <td align="right">
                        <div style={{display:'flex', justifyContent:'space-between'}}>
                          <span style={{fontWeight:'400'}}>${" "}</span>
                          {Number(employee?.Ytd_State_Additional_Tax??0)?.toLocaleString('en-US', {
                          // style: 'currency',
                          // currency: 'USD',
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                          })}
                        </div>
                      </td>
                    </tr> */}
                    <tr>
                      <td >
                        State income tax
                      </td>
                      <td align="right">
                        <div style={{display:'flex', justifyContent:'space-between'}}>
                          <span style={{fontWeight:'400'}}>${" "}</span>
                          {(Number(employee?.Ppe_State_Withholding_Tax??0)+Number(employee?.Ppe_State_Additional_Tax??0))?.toFixed(2)?.toLocaleString('en-US', {
                          // style: 'currency',
                          // currency: 'USD',
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                          })}
                        </div>  
                      </td>
                      <td align="right">
                        <div style={{display:'flex', justifyContent:'space-between'}}>
                          <span style={{fontWeight:'400'}}>${" "}</span>
                          {(Number(employee?.Ytd_State_Withholding_Tax??0)+Number(employee?.Ytd_State_Additional_Tax??0))?.toFixed(2)?.toLocaleString('en-US', {
                          // style: 'currency',
                          // currency: 'USD',
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                          })}
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td >
                        Social security tax
                      </td>
                      <td align="right">
                        <div style={{display:'flex', justifyContent:'space-between'}}>
                          <span style={{fontWeight:'400'}}>${" "}</span>
                          {Number(employee.Ppe_Soc_Sec_Deduction)?.toLocaleString('en-US', {
                          // style: 'currency',
                          // currency: 'USD',
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                          })}
                        </div>
                      </td>
                      <td align="right">
                        <div style={{display:'flex', justifyContent:'space-between'}}>
                          <span style={{fontWeight:'400'}}>${" "}</span>
                          {Number(employee.Ytd_Soc_Sec_Deduction)?.toLocaleString('en-US', {
                          // style: 'currency',
                          // currency: 'USD',
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                          })}
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Medicare tax
                      </td>
                      <td align="right">
                        <div style={{display:'flex', justifyContent:'space-between'}}>
                          <span style={{fontWeight:'400'}}>${" "}</span>
                          {Number(employee.Ppe_Medicare_Deduction)?.toLocaleString('en-US', {
                          // style: 'currency',
                          // currency: 'USD',
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                          })}
                        </div>
                      </td>
                      <td align="right">
                        <div style={{display:'flex', justifyContent:'space-between'}}>
                          <span style={{fontWeight:'400'}}>${" "}</span>
                          {Number(employee.Ytd_Medicare_Deduction)?.toLocaleString('en-US', {
                          // style: 'currency',
                          // currency: 'USD',
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                          })}
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td >
                        Defined benefits, HP ,GP plan
                      </td>
                      <td align="right">
                        <div style={{display:'flex', justifyContent:'space-between'}}>
                          <span style={{fontWeight:'400'}}>${" "}</span>
                          {Number(employee?.Ppe_Retire_Db_Deduction??0)?.toLocaleString('en-US', {
                          // style: 'currency',
                          // currency: 'USD',
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                          })}
                        </div>
                      </td>
                      <td align="right">
                        <div style={{display:'flex', justifyContent:'space-between'}}>
                          <span style={{fontWeight:'400'}}>${" "}</span>
                          {Number(employee?.Ytd_Retire_Db_Deduction??0)?.toLocaleString('en-US', {
                          // style: 'currency',
                          // currency: 'USD',
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                          })}
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Defined Contribution plan
                      </td>
                      <td align="right">
                        <div style={{display:'flex', justifyContent:'space-between'}}>
                          <span style={{fontWeight:'400'}}>${" "}</span>
                          {Number(employee.Ppe_Retire_Dc_Deduction)?.toLocaleString('en-US', {
                          // style: 'currency',
                          // currency: 'USD',
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                          })}
                        </div>
                      </td>
                      <td align="right">
                        <div style={{display:'flex', justifyContent:'space-between'}}>
                          <span style={{fontWeight:'400'}}>${" "}</span>
                          {Number(employee.Ytd_Retire_Dc_Deduction)?.toLocaleString('en-US', {
                          // style: 'currency',
                          // currency: 'USD',
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                          })}
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Health insurance    : Pretax
                      </td>
                      <td>
                        <div style={{display:'flex', justifyContent:'space-between'}}>
                          <span style={{fontWeight:'400'}}>${" "}</span>
                          {Number(employee.Ppe_Health_Emp_Contrb)?.toLocaleString('en-US', {
                          // style: 'currency',
                          // currency: 'USD',
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                          })}
                        </div>
                      </td>
                      <td>
                        <div style={{display:'flex', justifyContent:'space-between'}}>
                          <span style={{fontWeight:'400'}}>${" "}</span>
                          {Number(employee.Ytd_Health_Emp_Contrb)?.toLocaleString('en-US', {
                          // style: 'currency',
                          // currency: 'USD',
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                          })}
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Dental insurance    : Pretax
                      </td>
                      <td>
                        <div style={{display:'flex', justifyContent:'space-between'}}>
                          <span style={{fontWeight:'400'}}>${" "}</span>
                          {Number(employee.Ppe_Dental_Emp_Contrb)?.toLocaleString('en-US', {
                          // style: 'currency',
                          // currency: 'USD',
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                          })}
                        </div>
                      </td>
                      <td>
                        <div style={{display:'flex', justifyContent:'space-between'}}>
                          <span style={{fontWeight:'400'}}>${" "}</span>
                          {Number(employee.Ytd_Dental_Emp_Contrb)?.toLocaleString('en-US', {
                          // style: 'currency',
                          // currency: 'USD',
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                          })}
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Life insurance    : Pretax
                      </td>
                      <td>
                        <div style={{display:'flex', justifyContent:'space-between'}}>
                          <span style={{fontWeight:'400'}}>${" "}</span>
                          {Number(employee.Ppe_Life_Emp_Contrb)?.toLocaleString('en-US', {
                          // style: 'currency',
                          // currency: 'USD',
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                          })}
                        </div>
                      </td>
                      <td>
                        <div style={{display:'flex', justifyContent:'space-between'}}>
                          <span style={{fontWeight:'400'}}>${" "}</span>
                          {Number(employee.Ytd_Life_Emp_Contrb)?.toLocaleString('en-US', {
                          // style: 'currency',
                          // currency: 'USD',
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                          })}
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td style={{ paddingLeft: '15px', fontWeight:'bold',whiteSpace: "nowrap" }}>
                        Statutory withholding total
                      </td>
                      <td align="right">
                        <div style={{display:'flex', justifyContent:'space-between',fontWeight:'bold'}}>
                          <span>${" "}</span>
                          {(
                           Number(employee?.Ppe_Guam_Withholding_Tax??0) +
                          //  Number(employee?.Ppe_Guam_Additional_Tax??0)+
                           Number(employee?.Ppe_Federal_Withholding_Tax??0) +
                           Number(employee?.Ppe_Federal_Additional_Tax??0) +
                           Number(employee?.Ppe_State_Withholding_Tax??0) +
                           Number(employee?.Ppe_State_Additional_Tax??0) +
                           Number(employee.Ppe_Soc_Sec_Deduction) +
                           Number(employee.Ppe_Medicare_Deduction) +
                           Number(employee.Ppe_Retire_Db_Deduction) +
                           Number(employee.Ppe_Retire_Dc_Deduction) +
                           (employee?.Ppe_Health_Emp_Contrb ?? 0) +
                           (employee?.Ppe_Dental_Emp_Contrb ?? 0) +
                           (employee?.Ppe_Life_Emp_Contrb ?? 0)).toLocaleString('en-US', {
                            //style: 'currency',
                            //currency: 'USD',
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </div>
                      </td>
                      <td align="right">
                        <div style={{display:'flex', justifyContent:'space-between',fontWeight:'bold'}}>
                          <span>${" "}</span>
                          {(Number(employee?.Ytd_Guam_Withholding_Tax??0) +  Number(employee?.Ytd_Federal_Withholding_Tax??0) + Number(employee?.Ytd_Federal_Additional_Tax??0) + Number(employee?.Ytd_State_Withholding_Tax??0) + Number(employee?.Ytd_State_Additional_Tax??0) + Number(employee?.Ytd_Soc_Sec_Deduction??0) + Number(employee?.Ytd_Medicare_Deduction??0) + 
                          Number(employee?.Ytd_Retire_Db_Deduction??0) 
                          + Number(employee?.Ytd_Retire_Dc_Deduction??0) + Number(employee?.Ytd_Health_Emp_Contrb??0) + Number(employee?.Ytd_Dental_Emp_Contrb??0) + Number(employee?.Ytd_Life_Emp_Contrb??0)).toLocaleString('en-US', {
                          //style: 'currency',
                         // currency: 'USD',
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </Grid>
              <Grid item xs={11} paddingRight={"1px"}>
                <table style={{ width: '100%' }}>
                  <thead>
                    <tr>
                      <td style={{ fontWeight: 'bold', textDecoration: 'underline',whiteSpace: "nowrap" }}></td>
                      {/* <td align="right" style={{fontWeight:'500'}}>Account</td> */}
                      <td align="right" style={{fontWeight:'500'}}>
                        Current
                      </td>
                      <td align="right"  style={{fontWeight:'500'}}>
                        YTD
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    {/* <tr>
                      <td >
                        WELLS FARGO BANK, N.A. - PAYROLL
                      </td>
                      <td></td>
                      <td align="right">
                        <div style={{display:'flex', justifyContent:'space-between'}}>
                          <span style={{fontWeight:'400'}}>${" "}</span>
                          {(+((employee.Ppe_Gross_Earnings - employee.Ppe_Tax_Defered_Amount) - (employee.Ppe_Guam_Withholding_Tax + employee.Ppe_Medicare_Deduction))).toLocaleString('en-US', {
                          // style: 'currency',
                          // currency: 'USD',
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                        </div>
                      </td>
                      <td align="right">
                        <div style={{display:'flex', justifyContent:'space-between'}}>
                          <span style={{fontWeight:'400'}}>${" "}</span>
                          {(+((employee.Ytd_Gross_Earnings - employee.Ytd_Tax_Defered_Amount) - (employee.Ytd_Guam_Withholding_Tax + employee.Ytd_Medicare_Deduction))).toLocaleString('en-US', {
                          // style: 'currency',
                          // currency: 'USD',
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                        </div>
                      </td>
                    </tr> */}
                    {deductionVendor && deductionVendor.map((item)=><tr>
                      <td style={{whiteSpace: "nowrap"}}>{item?.Vendor_Name}</td>
                      {/* <td align="right">{item?.Acct_number??item?.Acc_number??"NA"}</td> */}
                      <td align="right">
                        <div style={{display:'flex', justifyContent:'space-between'}}>
                          <span style={{fontWeight:'400'}}>${" "}</span>
                          {(+(item?.Deduction_Value??0)).toLocaleString('en-US', {
                          // style: 'currency',
                          // currency: 'USD',
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                        </div>
                      </td>
                      <td align="right">
                        <div style={{display:'flex', justifyContent:'space-between'}}>
                          <span style={{fontWeight:'400'}}>${" "}</span>
                          {(+(item?.Deduction_Amount_ytd??0)).toLocaleString('en-US', {
                          // style: 'currency',
                          // currency: 'USD',
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                        </div>
                      </td>
                    </tr>)}
                    <tr>
                      <td style={{ paddingLeft: '15px', fontWeight:'bold' ,whiteSpace: "nowrap"}}>
                        Total withholding & deductions
                      </td>
                      {/* <td></td> */}
                      <td align="right">
                        <div style={{display:'flex', justifyContent:'space-between',fontWeight:'bold'}}>
                          <span>${" "}</span>
                          {(
                           Number(employee?.Ppe_Guam_Withholding_Tax??0) +
                          //  Number(employee?.Ppe_Guam_Additional_Tax??0)+
                           Number(employee?.Ppe_Federal_Withholding_Tax??0) +
                           Number(employee?.Ppe_Federal_Additional_Tax??0) +
                           Number(employee?.Ppe_State_Withholding_Tax??0) +
                           Number(employee?.Ppe_State_Additional_Tax??0) +
                           Number(employee?.Ppe_Soc_Sec_Deduction??0) +
                           Number(employee?.Ppe_Medicare_Deduction??0) +
                           Number(employee?.Ppe_Retire_Db_Deduction) +
                           Number(employee?.Ppe_Retire_Dc_Deduction??0) +
                           Number(employee?.Ppe_Health_Emp_Contrb ?? 0) +
                           Number(employee?.Ppe_Dental_Emp_Contrb ?? 0) +
                           Number(employee?.Ppe_Life_Emp_Contrb ?? 0)+
                           Number(deductionVendorSum?.Deduction_Value??0)).toLocaleString('en-US', {
                            //style: 'currency',
                            //currency: 'USD',
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </div>
                      </td>
                      <td align="right">
                        <div style={{display:'flex', justifyContent:'space-between',fontWeight:'bold'}}>
                          <span>${" "}</span>
                          {(Number(employee?.Ytd_Guam_Withholding_Tax??0) + Number(employee?.Ytd_Federal_Withholding_Tax??0) + Number(employee?.Ytd_Federal_Additional_Tax??0) + Number(employee?.Ytd_State_Withholding_Tax??0) + Number(employee?.Ytd_State_Additional_Tax??0) + Number(employee?.Ytd_Soc_Sec_Deduction??0) + Number(employee?.Ytd_Medicare_Deduction??0) + Number(employee?.Ytd_Retire_Db_Deduction??0) + Number(employee?.Ytd_Retire_Dc_Deduction??0) + Number(employee?.Ytd_Health_Emp_Contrb??0) + Number(employee?.Ytd_Dental_Emp_Contrb??0) + Number(employee?.Ytd_Life_Emp_Contrb??0) + Number(deductionVendorSum?.Deduction_Amount_ytd??0)).toLocaleString('en-US', {
                          //style: 'currency',
                         // currency: 'USD',
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </Grid>
            </Grid>
            {/* <Grid container spacing={2} >
              <Grid item xs={11} >
                <table style={{ width: '100%' }}>
                  <thead>
                    <tr>
                      <td align="right">Account</td>
                      <td align="right">
                        Current
                      </td>
                      <td align="right">
                        YTD
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td >
                        WELLS FARGO BANK, N.A. - PAYROLL
                      </td>

                      <td align="right">{+((employee.Ppe_Gross_Earnings - employee.Ppe_Tax_Defered_Amount) - (employee.Ppe_Guam_Withholding_Tax + employee.Ppe_Medicare_Deduction)).toFixed(2)}</td>
                      <td align="right">{+((employee.Ytd_Gross_Earnings - employee.Ytd_Tax_Defered_Amount) - (employee.Ytd_Guam_Withholding_Tax + employee.Ytd_Medicare_Deduction)).toFixed(2)}</td>
                    </tr>
                    <tr>
                      <td style={{ paddingLeft: '15px' }}>
                        Total withholding & deductions
                      </td>

                      <td align="right">{+(((employee.Ppe_Gross_Earnings - employee.Ppe_Tax_Defered_Amount) - (employee.Ppe_Guam_Withholding_Tax + employee.Ppe_Medicare_Deduction)) + (employee.Ppe_Guam_Withholding_Tax + employee.Ppe_Federal_Withholding_Tax + employee.Ppe_State_Withholding_Tax + employee.Ppe_Soc_Sec_Deduction + employee.Ppe_Medicare_Deduction + employee.Ppe_Retire_Db_Deduction + employee.Ppe_Retire_Dc_Deduction + employee.Emp_Health_Insurance + employee.Emp_Dental_Insurance + employee.Emp_Life_Insurance)).toFixed(2)}</td>
                      <td align="right">{+(((employee.Ytd_Gross_Earnings - employee.Ytd_Tax_Defered_Amount) - (employee.Ytd_Guam_Withholding_Tax + employee.Ytd_Medicare_Deduction)) + (employee.Ytd_Guam_Withholding_Tax + employee.Ytd_Federal_Withholding_Tax + employee.Ytd_State_Withholding_Tax + employee.Ytd_Soc_Sec_Deduction + employee.Ytd_Medicare_Deduction + employee.Ytd_Retire_Db_Deduction + employee.Ytd_Retire_Dc_Deduction + employee.Emp_Health_Insurance + employee.Emp_Dental_Insurance + employee.Emp_Life_Insurance)).toFixed(2)}</td>
                    </tr>

                  </tbody>
                </table>
              </Grid>

            </Grid> */}
            {/* <Divider style={{ height: '3px', backgroundColor: 'black', margin: '30px 0' }} /> */}
          </div>
        ))}

      </div>







    </>
  )
}

export default Reports